import { API } from '@Providers';

export default async function (specie: string) {
  const endpoint = `/api/shelter/get-adoption-fees/${specie}`;

  return API({ endpoint });
}
